/**
 * The ONE shared blank-value message (TASK-VTI-TEXT-FIELD CHG-004;
 * SPEC-FRONTEND-RULE-097 (2), D-378).
 *
 * There is exactly one string for "this value is only invisible characters",
 * and every surface renders THIS one: the `VisibleTextField` wrapper, the
 * `ExpandableTextField` `visibleTextCheck` variant, and any form that cannot
 * use either and calls `useVisibleTextError` directly. A second wording would
 * be a second rule in the user's eyes.
 *
 * It is a `msg` descriptor rather than a `t` call so it can live outside a
 * component and still be extracted into the catalogs, and so the locale the
 * user is reading resolves it at render time.
 *
 * Constraints this string is written under:
 *
 * - it names NO internal key, field path or stored value, because a refused
 *   value is never echoed back (RULE-INTEG-031, the no-echo promise);
 * - it is fix-oriented, not a generic "invalid input" (SPEC-FRONTEND-RULE-043):
 *   it says what is in the field and what the two ways out are;
 * - ASCII hyphen only, no em or en dash (SPEC-FRONTEND-RULE-064 / DASH-GATE);
 * - it is never width-fixed or truncated by its consumers, because the
 *   Hungarian is the longer of the two (SPEC-FRONTEND-RULE-047).
 *
 * @module components/shared/VisibleTextField/messages
 */
import { msg } from "@lingui/core/macro";

/**
 * Shown on a field whose value is non-empty and consists only of code points
 * that show the reader nothing (spaces, control characters, zero-width marks).
 *
 * The empty string is NOT this case and is never flagged: an empty value keeps
 * whatever meaning its form gives it (inherit, clear, absent).
 */
export const blankValueMessage = msg`Only spaces or invisible characters. Enter visible text, or clear the field.`;
